import { create } from 'zustand';
import { notificationsApi } from '@/services/notifications.api';

/**
 * Compteur de notifications non lues - partagé entre Sidebar (badge),
 * NotificationBell (increment WS) et NotificationsPage (decrement sur
 * markRead). Une seule source de vérité évite les désynchronisations
 * (badge à 3 alors que la page ne montre plus de non lues, etc.).
 */
interface NotificationsCountStore {
  count: number;
  refresh: (token: string) => Promise<void>;
  increment: () => void;
  decrement: () => void;
  reset: () => void;
}

export const useNotificationsCountStore = create<NotificationsCountStore>((set) => ({
  count: 0,
  refresh: async (token) => {
    try {
      const res = await notificationsApi.unreadCount(token);
      set({ count: res.count });
    } catch {
      /* silencieux - le badge n'est pas critique */
    }
  },
  increment: () => set((s) => ({ count: s.count + 1 })),
  decrement: () => set((s) => ({ count: Math.max(0, s.count - 1) })),
  reset: () => set({ count: 0 }),
}));
